import React, { useState, Fragment, useRef } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import AlarmIcon from '@mui/icons-material/Alarm';

import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';
import Barcode from 'react-barcode';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Checkbox from '@mui/material/Checkbox';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import * as XLSX from "xlsx";
function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,

) {
    return { name, calories, fat, carbs };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),

];


const ManageConferencePartitcpnatOrder = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid')
    const eventname = localStorage.getItem('eventname')
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = React.useState(() => {
        return parseInt(localStorage.getItem('tablePage')) || 0;
    })
    const [rowsPerPage, setRowsPerPage] = React.useState(() => {
        return parseInt(localStorage.getItem('tableRowsPerPage')) || 10;
    });

    const [searchText, setSearchText] = useState('');

    const [permissions, setrPermissions] = useState([]);
    const [allData, setAllData] = useState([]);
    const [participantIndex, setParticipantIndex] = useState([]);
    const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);

    const [workshopUsedCoupeon, setWorkshopUsedCoupeon] = useState([]);
    const [copiedStates, setCopiedStates] = useState({});
    const [openModalReceipt, setOpenModalReceipt] = useState(false);
    const [isButtonReminderDisabled, setIsButtonReminderDisabled] = useState(false);
    const [isButtonPrintReceiptReminderDisabled, setIsButtonPrintReceiptReminderDisabled] = useState(false);
    const [isButtonSendReceiptReminderDisabled, setIsButtonSendReceiptReminderDisabled] = useState(false);
    const [isButtonSendCustomReminderDisabled, setIsButtonSendCustomReminderDisabled] = useState(false);
    const [isButoonSendWhatsappReminderDisabled, setIsButoonSendWhatsappReminderDisabled] = useState(false);

    const [openModalBank, setOpenModalBank] = useState(false);
    const [openModalView, setOpenModalView] = useState(false);
    const [openModalWorkshop, setOpenModalWorkshop] = useState(false);
    const [conferenceTotalSeatCount, setConferenceTotalSeatCount] = useState();
    const [participantSingleData, setParticipantSingleData] = useState({
        id: "",
        participant_workshop_categoy_id: "",
        name_title: "",
        participant_name: "",
        participant_saudi_council_no: "",
        participant_email: "",
        password: "",
        participant_profession: "",


    });
    const [showBarcode, setShowBarcode] = useState(null);
    const [printingId, setPrintingId] = useState(null);
    const printRef = useRef();
    const [selectedOptions, setSelectedOptions] = useState({});
    const [filterPaymentStatus, setFilterPaymentStatus] = useState('all'); // 'all', 'paid', 'unpaid'
    const [openModalChallan, setOpenModalChallan] = useState(false);
    const [challandata, setChallandata] = useState('');

    const [updatedParticipant, setUpdatedParticipant] = useState(null);
    const [refreshTable, setRefreshTable] = useState(false);
    const [addBank, setAddBank] = useState({
        participant_id: `${participantSingleData.id || ""}`,
        bank_name: "",
        trans_ref_no: "",

    });

    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermID, setSearchTermID] = useState('');
    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleIDInputChange = (e) => {
        setSearchTermID(e.target.value);
    };


    const handleClickVerify = () => {
        setShowAdditionalButtons(!showAdditionalButtons);
    };

    React.useEffect(() => {
        return () => {
            setAllData(rows)
        };
    }, []);

    const handleFilterPaymentStatusChange = (event) => {
        setFilterPaymentStatus(event.target.value);
    };

    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);



    React.useEffect(() => {
        axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const cpartiticpantData = res.data.cpindex;

                setParticipantIndex(cpartiticpantData);
            }

            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);





    const CustomFieldDelete = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = " Deleting..."
        axios.get(`api/status-list-customfield/${id}`).then(res => {
            if (res.data.status === 200) {
                //swal("Success", res.data.message, "success");
                thisClicked.closest("tr").remove();
            }
            else if (res.data.status === 404) {
                this.innText = "delete";
            }
        });
    }


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        localStorage.setItem('tablePage', newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0); // usually reset to first page when rows per page changes
        localStorage.setItem('tableRowsPerPage', newRowsPerPage);
        localStorage.setItem('tablePage', 0);
    };

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };


    const filteredRows = rows.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;


    const filteredPosts = participantIndex?.filter((row) => {
        const idMatches = row.id && row.id.toString().toLowerCase() === searchTermID?.toLowerCase();
        const nameMatches = row.participant_name && row.participant_name.toLowerCase().includes(searchTerm?.toLowerCase());
        const emailMatches = row.participant_email && row.participant_email.toLowerCase().includes(searchTerm?.toLowerCase());
        const phoneMatches = row.participant_phone_number && row.participant_phone_number.toLowerCase().includes(searchTerm?.toLowerCase());

        const transRefNoMatches = row.cppyament && row.cppyament.some((payment) =>
            payment.trans_ref_no && payment.trans_ref_no.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        const paymentMethodMatches = row.cppyament && row.cppyament.some((payment) =>
            payment.payment_method && payment.payment_method.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        const paymentTypeMatches = row.cppyament && row.cppyament.some((payment) =>
            payment.payment_type && payment.payment_type.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        const paymentStatusMatches = row.cppyament && row.cppyament.some((payment) => {
            const statusLowerCase = payment.status === 0 ? 'no' : 'yes';
            return searchTerm?.toLowerCase().includes(statusLowerCase);
        });
        // console.log("row.cppyament", row.cppyament)
        const paymentStatusPaidUnpaid = row.cppyament && row.cppyament.some((payment) => {
            if (filterPaymentStatus === 'all') {
                return true; // Always include when 'all' is selected
            } else if (filterPaymentStatus === 'paid') {
                return payment.status !== 0 && payment.payment_method !== 'Free'; // Include if payment is paid
            } else if (filterPaymentStatus === 'unpaid') {
                return payment.status === 0; // Include if payment is unpaid
            }
            else if (filterPaymentStatus === 'free') {
                return payment.status !== 0 && payment.payment_method === 'Free' && payment.total_paid_amount === "0.0000"; // Include if payment is free 

            }
            else if (filterPaymentStatus === 'allverified') {
                return payment.status !== 0; // Include if payment is free 

            }
            return false;
        });

        // Combine all conditions
        const finalResult = (!searchTermID || idMatches) &&
            (nameMatches || emailMatches || phoneMatches || transRefNoMatches || paymentMethodMatches || paymentTypeMatches || paymentStatusMatches) &&
            paymentStatusPaidUnpaid;

        return finalResult;
    });

    const totalRecords = participantIndex?.length;
    const filteredRecordsCount = filteredPosts?.length;


    const handleConferenceVerifiedDownloadCSV = () => {
        axios.get(`api/conference-participant-verified?id=${eventid}`)
            .then((res) => {
                if (res.status === 200) {
                    const verifiedData = res.data.data;

                    if (verifiedData.length === 0) {
                        swal('No Data', 'No new verified participants to export.', 'info');
                        return; // Exit the function before attempting download
                    }

                    const csvData = verifiedParticpantConvertToCSV(verifiedData);
                    const csvBlob = new Blob([csvData], { type: 'text/csv' });
                    const csvUrl = window.URL.createObjectURL(csvBlob);
                    const downloadLink = document.createElement('a');
                    downloadLink.href = csvUrl;
                    downloadLink.download = 'Verified_Conference_Participants.csv';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                } else {
                    swal('Error', 'Error downloading verified participants.', 'error');
                }
            })
            .catch(() => {
                swal('Error', 'Something went wrong.', 'error');
            });
    };
    const verifiedParticpantConvertToCSV = (data) => {
        // Define the mapping between original data keys and display names
        const fieldMappings = {
            'id': 'ID',
            'name_title': 'Title',
            'participant_name': 'Name',
            'participant_saudi_council_no': 'Saudi Council No',
            'participant_email': 'Email',
            'participant_phone_number': 'Mobile Number',


        };

        // Define the fields you want to include in the CSV
        const fields = Object.keys(fieldMappings);

        // Create the CSV header using the display names
        const header = fields.map(field => fieldMappings[field]).join(',');

        // Create the CSV body with data for selected fields
        const body = data.map(row => {
            // Extract values for selected fields
            const filteredRow = fields.map(field => {
                if (field === 'payment_status') {
                    return row.cppyament && row.cppyament.some(cppyament => cppyament.status === 0) ? 'no' : 'yes';
                } else if (field === 'conference') {
                    if (Array.isArray(row.cpconference)) {
                        // Extract workshop codes and their payment statuses and concatenate them with commas and spaces
                        const conferenceData = row.cpconference.map(conference =>
                            `${conference.conference_name} (${conference.conference_day}, ${conference.payment_status === 0 ? 'Unpaid' : 'Paid'})`
                        ).join('; ');
                        return `"${conferenceData}"`; // Enclose entire workshop data in double quotes
                    } else {
                        return ''; // Empty string if no workshops available
                    }
                } else {
                    return row[field] || ''; // Ensure to handle potential undefined values
                }
            });
            return filteredRow.join(',');
        }).join('\n');

        return `${header}\n${body}`;
    };



    const handleConferenceDownloadCSV = () => {
        const csvData = convertToCSV(filteredPosts);
        const csvBlob = new Blob([csvData], { type: 'text/csv' });
        const csvUrl = window.URL.createObjectURL(csvBlob);
        const downloadLink = document.createElement('a');
        downloadLink.href = csvUrl;
        downloadLink.download = 'Conference_participent_data.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };



    const convertToCSV = (data) => {
        // Define the mapping between original data keys and display names
        const fieldMappings = {
            'name_title': 'Title',
            'participant_name': 'Name',
            'participant_saudi_council_no': 'Saudi Council No',
            'participant_email': 'Email',
            'participant_phone_number': 'Mobile Number',
            'payment_status': 'Payment Status',
            'conference': 'Conference and Day',

        };

        // Define the fields you want to include in the CSV
        const fields = Object.keys(fieldMappings);

        // Create the CSV header using the display names
        const header = fields.map(field => fieldMappings[field]).join(',');

        // Create the CSV body with data for selected fields
        const body = data.map(row => {
            // Extract values for selected fields
            const filteredRow = fields.map(field => {
                if (field === 'payment_status') {
                    return row.cppyament && row.cppyament.some(cppyament => cppyament.status === 0) ? 'no' : 'yes';
                } else if (field === 'conference') {
                    if (Array.isArray(row.cpconference)) {
                        // Extract workshop codes and their payment statuses and concatenate them with commas and spaces
                        const conferenceData = row.cpconference.map(conference =>
                            `${conference.conference_name} (${conference.conference_day}, ${conference.payment_status === 0 ? 'Unpaid' : 'Paid'})`
                        ).join('; ');
                        return `"${conferenceData}"`; // Enclose entire workshop data in double quotes
                    } else {
                        return ''; // Empty string if no workshops available
                    }
                } else if (field === 'participant_phone_number') {

                    return `'${row[field] || ''}`;
                } else {
                    return row[field] || ''; // Ensure to handle potential undefined values
                }
            });
            return filteredRow.join(',');
        }).join('\n');

        return `${header}\n${body}`;
    };


    // const handleConferenceDownloadExcel = () => {
    //     // Map your data into the shape you want
    //     const fieldMappings = {
    //         'name_title': 'Title',
    //         'participant_name': 'Name',
    //         'participant_saudi_council_no': 'Saudi Council No',
    //         'participant_email': 'Email',
    //         'participant_phone_number': 'Mobile Number',
    //         'payment_status': 'Payment Status',
    //         'conference': 'Conference and Day',
    //     };

    //     const fields = Object.keys(fieldMappings);

    //     const formattedData = filteredPosts.map(row => {
    //         return {
    //             Title: row.name_title || '',
    //             Name: row.participant_name || '',
    //             'Saudi Council No': row.participant_saudi_council_no || '',
    //             Email: row.participant_email || '',
    //             'Mobile Number': row.participant_phone_number ? String(row.participant_phone_number) : '',
    //             'Payment Status': row.cppyament && row.cppyament.some(cppyament => cppyament.status === 0) ? 'no' : 'yes',
    //             'Conference and Day': Array.isArray(row.cpconference)
    //                 ? row.cpconference.map(conference =>
    //                     `${conference.conference_name} (${conference.conference_day}, ${conference.payment_status === 0 ? 'Unpaid' : 'Paid'})`
    //                 ).join('; ')
    //                 : ''
    //         };
    //     });

    //     // Create worksheet & workbook
    //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Participants");

    //     // Force Mobile Number column to be text
    //     Object.keys(worksheet).forEach(cell => {
    //         if (cell[0] !== '!') {
    //             const col = cell.replace(/[0-9]/g, ""); // get column letter
    //             if (worksheet[cell].v && col === "E") { // column E is "Mobile Number"
    //                 worksheet[cell].t = "s"; // set type to string
    //             }
    //         }
    //     });

    //     XLSX.writeFile(
    //         workbook,
    //         eventname ? `${eventname}_Conference_participant_data.xlsx` : "Conference_participant_data.xlsx");// Fallback if eventname is not available
    // };


    const handleConferenceDownloadExcel = () => {
    // Map your data into the shape you want
    const fieldMappings = {
        'name_title': 'Title',
        'participant_name': 'Name',
        'participant_saudi_council_no': 'Saudi Council No',
        'participant_email': 'Email',
        'participant_phone_number': 'Mobile Number',
        'participant_profession': 'Profession',
        'participant_country': 'Country',
        'participant_city': 'City',
        'participant_gender': 'Gender',
        'conference_category': 'Conference Category',
        'payment_status': 'Payment Status',
        'conference': 'Conference and Day',
    };

    const fields = Object.keys(fieldMappings);

    const formattedData = filteredPosts.map(row => {
        // Format gender value
        const genderText = row.participant_gender === 0 ? 'Male' : 
                          row.participant_gender === 1 ? 'Female' : 
                          'Not Specified';

        return {
            Title: row.name_title || '',
            Name: row.participant_name || '',
            'Saudi Council No': row.participant_saudi_council_no || '',
            Email: row.participant_email || '',
            'Mobile Number': row.participant_phone_number ? String(row.participant_phone_number) : '',
            'Profession': row.participant_profession || '',
            'Country': row.participant_country || '',
            'City': row.participant_city || '',
            'Gender': genderText,
            'Conference Category': row.cpcategory ? row.cpcategory.conference_category_title || '' : '',
            'Payment Status': row.cppyament && row.cppyament.some(cppyament => cppyament.status === 0) ? 'no' : 'yes',
            'Conference and Day': Array.isArray(row.cpconference)
                ? row.cpconference.map(conference =>
                    `${conference.conference_name} (${conference.conference_day}, ${conference.payment_status === 0 ? 'Unpaid' : 'Paid'})`
                ).join('; ')
                : ''
        };
    });

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Participants");

    // Force Mobile Number column to be text
    Object.keys(worksheet).forEach(cell => {
        if (cell[0] !== '!') {
            const col = cell.replace(/[0-9]/g, ""); // get column letter
            if (worksheet[cell].v && col === "E") { // column E is "Mobile Number"
                worksheet[cell].t = "s"; // set type to string
            }
        }
    });

    XLSX.writeFile(
        workbook,
        eventname ? `${eventname}_Conference_participant_data.xlsx` : "Conference_participant_data.xlsx");// Fallback if eventname is not available
};

    const handleChange = (event, row) => {
        const { value } = event.target;
        setSelectedOptions((prevOptions) => ({
            ...prevOptions,
            [row.id]: value,
        }));
        handleSelection(value, row);
    };

    const handleSelection = (value, row) => {
        // Add logic based on the selected value and the row information
        switch (value) {
            case 'receipt':
                handleClickReceipt(row);
                break;
            case 'bank':
                handleClickBank(row);
                break;

            case 'qrcodeshow':
                handleClickQrCodeShow(row);
                break;
            // case 'cash':
            //     handleClickCash(row);
            //     break;

            default:
                break;
        }
    };


    const isCheckboxDisabled = (conference) => {
        const getConference = conference.conference;
        const checkConferenceSeat = conferenceTotalSeatCount?.filter(conf => conf.conference_id === getConference.id).length;
        const isSeatLimitReached = checkConferenceSeat >= getConference?.conference_no_ofseats;
        let seatLimitMessage = "";
        if (isSeatLimitReached) {
            seatLimitMessage = `${checkConferenceSeat} All Seats Full`;
        }
        const isDisabled = isSeatLimitReached;
        return { isDisabled, seatLimitMessage };
    };


    const handleClickView = (id) => {

        axios.get(`api/conference-participant-show/${eventid}/${id}`).then(res => {
            if (res.status === 200) {
                const data = res.data.csps;
                setParticipantSingleData(data);


            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        })

        setOpenModalView(true);
    };
    const handleCloseModalView = () => {
        setOpenModalView(false);
    };


    const handleClickViewConference = (id) => {

        axios.get(`api/conference-participant-show/${eventid}/${id}`).then(res => {
            if (res.status === 200) {
                const data = res.data.csps;

                setParticipantSingleData(data)
                setConferenceTotalSeatCount(res.data.totalSeatCount);
                data.cppyament.map((val) => {
                    setAddBank(val);
                });


            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        })

        setOpenModalWorkshop(true);
    };

    const handleCloseModalWorkshop = () => {
        setOpenModalWorkshop(false);
    };
    const [checkedWorkshops, setCheckedWorkshops] = useState({});

    const handleConferenceCheckboxChange = (workshopId) => {
        //console.log(workshopId)
        setCheckedWorkshops(prevState => ({
            ...prevState,
            [workshopId]: !prevState[workshopId] // Toggle the checked state
        }));
    };
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);

    React.useEffect(() => {
        // Check if at least one workshop is selected
        const hasCheckedWorkshops = Object.values(checkedWorkshops).some(isChecked => isChecked);
        setIsSaveButtonDisabled(!hasCheckedWorkshops);
    }, [checkedWorkshops]);



    const copyCoupon = (couponCode) => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                setCopiedStates(prevState => ({ ...prevState, [couponCode]: true }));
                setTimeout(() => {
                    setCopiedStates(prevState => ({ ...prevState, [couponCode]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };



    const grandTotalViewWorkshopAmount = participantSingleData?.cpconference?.reduce((acc, conference) => {
        if (conference.conference_amount) {
            return acc + parseFloat(conference.conference_amount);
        }
        return acc;
    }, 0);

    let totalDiscountedAmount = 0;

    participantSingleData?.cpconference?.forEach(conference => {
        // Initialize variable for discounted amount
        let discountedAmount = parseFloat(conference.conference_amount);

        // Calculate discounted amount for the current workshop
        if (participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0) {
            participantSingleData.cpcoupon
                .filter(coupon => coupon.conference_id === conference.conference_id) // Filter by workshop ID
                .forEach(coupon => {
                    // Determine the discount based on the coupon type
                    let discount = 0;
                    if (coupon.coupon_discount_type === 'fixed') {
                        discount = parseFloat(coupon.coupon_amount);
                    } else if (coupon.coupon_discount_type === 'percentage') {
                        // Calculate the percentage discount
                        const percentage = parseFloat(coupon.coupon_amount);
                        discount = (parseFloat(conference.conference_amount) * percentage) / 100;
                    }

                    // Calculate the final amount after discount
                    discountedAmount -= discount;
                });
        }

        // Add discounted amount for the current workshop to the total discounted amount
        totalDiscountedAmount += discountedAmount;
    });




    let totalUnPaidWorkshopAmount = 0;


    // Calculate total discounted amount across all workshops
    participantSingleData?.cpconference?.forEach(conference => {
        // Check if workshop payment status is unpaid and workshop amount exists
        if (conference.payment_status === 0 && conference.conference_amount) {
            // Initialize variable for discounted amount
            let discountedAmount = parseFloat(conference.conference_amount);

            // Calculate discounted amount for the current workshop
            if (participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0) {
                participantSingleData.cpcoupon
                    .filter(coupon => coupon.conference_id === conference.conference_id) // Filter by workshop ID
                    .forEach(coupon => {
                        // Determine the discount based on the coupon type
                        let discount = 0;
                        if (coupon.coupon_discount_type === 'fixed') {
                            discount = parseFloat(coupon.coupon_amount);
                        } else if (coupon.coupon_discount_type === 'percentage') {
                            // Calculate the percentage discount
                            const percentage = parseFloat(coupon.coupon_amount);
                            discount = (parseFloat(conference.conference_amount) * percentage) / 100;
                        }

                        // Calculate the final amount after discount
                        discountedAmount -= discount;
                    });
            }

            // Add discounted amount for the current workshop to the total discounted amount
            totalUnPaidWorkshopAmount += discountedAmount;
        }
    });

    let totalPaidWorkshopAmount = 0;
    participantSingleData?.cpconference?.forEach(conference => {
        // Check if workshop payment status is unpaid and workshop amount exists
        if (conference.payment_status === 1 && conference.conference_amount) {
            // Initialize variable for discounted amount
            let discountedAmount = parseFloat(conference.conference_amount);

            // Calculate discounted amount for the current workshop
            if (participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0) {
                participantSingleData.cpcoupon
                    .filter(coupon => coupon.conference_id === conference.conference_id) // Filter by workshop ID
                    .forEach(coupon => {
                        // Determine the discount based on the coupon type
                        let discount = 0;
                        if (coupon.coupon_discount_type === 'fixed') {
                            discount = parseFloat(coupon.coupon_amount);
                        } else if (coupon.coupon_discount_type === 'percentage') {
                            // Calculate the percentage discount
                            const percentage = parseFloat(coupon.coupon_amount);
                            discount = (parseFloat(conference.conference_amount) * percentage) / 100;
                        }

                        // Calculate the final amount after discount
                        discountedAmount -= discount;
                    });
            }

            // Add discounted amount for the current workshop to the total discounted amount
            totalPaidWorkshopAmount += discountedAmount;
        }
    });

    const totalViewWorkshopAmount = 0;
    const totalDiscountedAmountFormatted = totalDiscountedAmount.toFixed(2);
    const grandTotalViewWorkshopAmountFormatted = !isNaN(grandTotalViewWorkshopAmount) ? grandTotalViewWorkshopAmount.toFixed(2) : 0;
    const totalUnPaidWorkshopAmountFormatted = totalUnPaidWorkshopAmount.toFixed(2);
    // const totalDiscountedAmountFormatted = totalDiscountedAmount.toFixed(2);
    const totalViewWorkshopAmountFormatted = !isNaN(totalViewWorkshopAmount) ? totalViewWorkshopAmount.toFixed(2) : 0;
    const totalPaidWorkshopAmountFormatted = !isNaN(totalPaidWorkshopAmount) ? totalPaidWorkshopAmount.toFixed(2) : 0;
    //const totalUnPaidWorkshopAmountFormatted = !isNaN(totalPaidWorkshopAmount) ? totalUnPaidWorkshopAmount.toFixed(2) : 0;
    const [tabValueReceipt, setTabValueReceipt] = useState(0);
    const [tabsDataReceipt, setTabsDataReceipt] = useState([]);
    const bankReferanceNo = tabsDataReceipt.map(tab => tab.label);
    const bankNameforVeri = tabsDataReceipt.map(tab => tab.content);
    const handleWorkshopStatusSubmit = () => {
        const data = {
            eventid,
            participant_id: `${participantSingleData.id || ""}`,
            verifiConference: checkedWorkshops,
            //totalAmount: totalViewWorkshopAmount,
            totalAmount: totalDiscountedAmountFormatted,
            paidAmount: totalPaidWorkshopAmountFormatted,
            reminingAmount: totalUnPaidWorkshopAmountFormatted,
            participant_bank: addBank.bank_name ? addBank.bank_name : bankNameforVeri.join(' , '), // Conditionally set participant_bank
            participant_ref_no: addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join(' , '),
        };

        const id = participantSingleData.id;

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-particepant-conference-status-verification/${id}`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');
                    // Fetch the updated data after successful submission
                    //setCheckedWorkshops("")
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.cpindex;

                            setParticipantIndex(wcategoryData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                        }
                    });

                    history.push('/admin/conference/manage-particpant-order');
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });
        setCheckedWorkshops("")
        setOpenModalWorkshop(false); // Close the dialog box
        // Add your logic to submit the form or perform any other action
    };

    const [openModalWorkshopRecepit, setOpenModalWorkshopRecepit] = useState(false);
    const handleClickOpenlWorkshopRecepit = () => {
        setOpenModalWorkshopRecepit(true);
    };
    const handleClose = () => {
        setOpenModalWorkshopRecepit(false);

    };


    React.useEffect(() => {
        // Check if participantSingleData and wpbank_pay_tran are defined and if wpbank_pay_tran is an array
        if (participantSingleData && Array.isArray(participantSingleData.cpbank_pay_tran)) {
            // Map over wpbank_pay_tran if it's defined and an array
            const bankPaymentData = participantSingleData.cpbank_pay_tran.map((bankDetails, key) => ({
                label: bankDetails.trans_ref_no,
                content: bankDetails.bank_name,
                //imageUrl: participantSingleData.base_url ? `${participantSingleData.base_url}/workshop/${bankDetails.receipt_image}` : ''
                imageUrl: bankDetails.image_url ? bankDetails.image_url : ''
            }));

            // Update state with bankPaymentData
            setTabsDataReceipt(bankPaymentData);
        } else {
            // Handle case where participantSingleData or cpbank_pay_tran is undefined or not an array
            console.log("Error: participantSingleData or wpbank_pay_tran is undefined or not an array");
        }
    }, [participantSingleData]); // Add participantSingleData to the dependency array to ensure useEffect runs when it changes




    const handleReceiptTabChange = (event, newValue) => {
        setTabValueReceipt(newValue);
    };




    const [addReceipt, setAddReceipt] = useState({
        participant_id: `${participantSingleData.id || ""}`,
        participant_bank: "",
        participant_ref_no: "",

    });
    const handleInputReceipt = (e) => {
        setAddReceipt({ ...addReceipt, [e.target.name]: e.target.value });

    }
    const filteredConference = Object.fromEntries(
        Object.entries(checkedWorkshops).filter(([key, value]) => value) // Keep only truthy values
    );
    const addReceiptData = (e) => {
        e.preventDefault();
        const receiptVerifictions = "receiptVerifictions";
        //on this comment replace the banksubmit
        const data = {
            eventid,
            participant_id: `${participantSingleData.id || ""}`,
            participant_bank: addReceipt.participant_bank, // Conditionally set participant_bank
            participant_ref_no: addReceipt.participant_ref_no,
            receiptVerifictions,
            verifiConference: filteredConference,
            //totalAmount: totalViewWorkshopAmount,
            totalAmount: totalDiscountedAmountFormatted,

            //  totalAmount: totalDiscountedAmountFormatted,
            // paidAmount: totalPaidWorkshopAmountFormatted,
            // reminingAmount: totalUnPaidWorkshopAmountFormatted,



        }
        const id = participantSingleData.id;


        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-particepant-bank-verification/${id}`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');
                    // Fetch the updated data after successful submission
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const cpartiticpantData = res.data.cpindex;
                            setParticipantIndex(cpartiticpantData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                        }
                    });



                    history.push('/admin/conference/manage-particpant-order');
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });

        });
        setAddReceipt({
            participant_id: `${participantSingleData.id || ""}`,
            participant_bank: "",
            participant_ref_no: "",
        });


        setCheckedWorkshops("")
        setOpenModalReceipt(false);
    };

    const handleClickReceipt = (row) => {
        const strconfirm = window.confirm("Are you sure you want to verify..");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            const id = row.id;
            axios.get(`api/conference-participant-show/${eventid}/${id}`).then(res => {
                if (res.status === 200) {
                    const data = res.data.csps;

                    setParticipantSingleData(data);
                    data.cppyament.map((val) => {
                        setAddBank(val);
                    });
                    setConferenceTotalSeatCount(res.data.totalSeatCount);

                } else {
                    swal('Error', "Check API Something Wrong", 'error');
                }
            })
        }


        setOpenModalReceipt(true);

    };


    const handleCloseModal = () => {
        setOpenModalReceipt(false);
    };
    const handlechangeReceipt = (e) => {
        setAddReceipt({ ...addReceipt, [e.target.name]: e.target.value });
    }



    const handlechangeBank = (e) => {
        setAddBank({ ...addBank, [e.target.name]: e.target.value });
    }


    const submitBankData = (e) => {

        e.preventDefault();
        const bankVerifictions = "bankVerifictions";


        const data = {
            eventid,
            participant_id: `${participantSingleData.id || ""}`,
            participant_bank: addBank.bank_name ? addBank.bank_name : bankNameforVeri.join(' , '), // Conditionally set participant_bank
            participant_ref_no: addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join(' , '),
            bankVerifictions,
            verifiConference: filteredConference,
            //totalAmount: totalViewWorkshopAmount,

            totalAmount: totalDiscountedAmountFormatted,
            paidAmount: totalPaidWorkshopAmountFormatted,
            reminingAmount: totalUnPaidWorkshopAmountFormatted,



        }
        const id = participantSingleData.id;




        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-particepant-bank-verification/${id}`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');
                    // Fetch the updated data after successful submission
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const cpartiticpantData = res.data.cpindex;
                            setParticipantIndex(cpartiticpantData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                        }
                    });



                    history.push('/admin/conference/manage-particpant-order');
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });


        // // swal("Success", "Verifie SuccessFully Through Bank", "success")

        setAddBank({
            participant_id: `${participantSingleData.id || ""}`,
            bank_name: "",
            trans_ref_no: "",
        });
        setCheckedWorkshops("")


        // Close the modal
        setOpenModalBank(false);

    };

    React.useEffect(() => {
        if (updatedParticipant) {
            setParticipantIndex(prevParticipantIndex => {
                return prevParticipantIndex.map(item => (item.id === updatedParticipant.id ? updatedParticipant : item));
            });
        }
    }, [updatedParticipant]);




    const handleClickBank = (row) => {

        const strconfirm = window.confirm("Are you sure you want to verify.. ");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            const id = row.id;
            axios.get(`api/conference-participant-show/${eventid}/${id}`).then(res => {
                if (res.status === 200) {
                    const data = res.data.csps;

                    setParticipantSingleData(data);
                    data.cppyament.map((val) => {
                        setAddBank(val);
                    });
                    setConferenceTotalSeatCount(res.data.totalSeatCount);

                } else {
                    swal('Error', "Check API Something Wrong", 'error');
                }
            })
        }



        setOpenModalBank(true);
    };
    const handleCloseModalBank = () => {
        setOpenModalBank(false);
    };





    const handleClickQrCodeShow = (row) => {
        const id = row.id;
        const qrStatusOn = "qrStatusOn";
        const data = {
            eventid,
            participant_id: id,
            qrStatusOn,
            verifiConference: "empty",


        }

        const strconfirm = window.confirm("Are you sure you want to verify..");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            axios.get('/sanctum/csrf-cookie').then(response => {

                axios.post(`/api/conference-particepant-status-qrcodestatus/${id}`, data).then(res => {

                    if (res.data.status === 200) {


                        swal('Success', res.data.message, 'success');

                        axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                            if (res.status === 200) {
                                const wcategoryData = res.data.cpindex;
                                setParticipantIndex(wcategoryData);
                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                            }
                        });

                        history.push('/admin/conference/manage-particpant-order');
                    }
                    else {

                        setAddBank({ ...addBank, error_list: res.data.validate_error })

                    }

                });


            });


        }
    }


    const handleClickCash = (row) => {
        const id = row.id;

        const cashVerifictions = "cashVerifictions";


        const data = {
            eventid,
            participant_id: `${participantSingleData.id || ""}`,
            participant_bank: addBank.participant_bank,
            participant_ref_no: addBank.participant_ref_no,
            cashVerifictions,
            verifiWorkshop: filteredConference,
            totalAmount: totalDiscountedAmountFormatted,

        }



        const strconfirm = window.confirm("Are you sure you want to verify..");
        if (strconfirm == false) {
            return swal('Error', "Not Verifyed", 'error');
        }
        else {
            axios.get('/sanctum/csrf-cookie').then(response => {

                axios.post(`/api/orkshop-particepant-bank-verification/${id}`, data).then(res => {

                    if (res.data.status === 200) {


                        swal('Success', "Verifie SuccessFully Through Cash", 'success');
                        // Fetch the updated data after successful submission
                        axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
                            if (res.status === 200) {
                                const wcategoryData = res.data.wpindex;
                                setParticipantIndex(wcategoryData);
                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                            }
                        });

                        history.push('/admin/workshop/manage-particpant-order');
                    }
                    else {

                        setAddBank({ ...addBank, error_list: res.data.validate_error })

                    }

                });


            });


        }


    };





    const handleModalChallan = (cppyament) => {
        const id = cppyament.id;

        axios.get(`api/conference-participant-pyament-challan/${eventid}/${id}`).then(res => {
            if (res.status === 200) {
                const data = res.data.cppc;
                setChallandata(data);
            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        });

        setOpenModalChallan(true);
    };





    const [openModalBankVeriChallan, setOpenModalBankVeriChallan] = useState(false);


    const handleModalBankReciept = (bankDeatials) => {
        // const id = bankDeatials.id;
        // alert(`bank Details: ${id}`)
        setOpenModalBankVeriChallan(true);
    };

    const handleCloseModalBankVeriChallan = () => {
        setOpenModalBankVeriChallan(false);
    };




    const handleCloseModalChallan = () => {
        setOpenModalChallan(false);
    };



    const handleClickReminderEmail = (row) => {

        const id = row.id;
        const paymentStatus = row.cppyament.some((cppyament) => cppyament.status)

        //alert(`Function accessed with ID: ${id} and paymentStatus: ${paymentStatus}`);


        const data = {
            eventid,
            paymentStatus,

        }
        setIsButtonReminderDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-participant-reminder-email-send/${id}`, data).then(res => {

                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');

                    // Fetch the updated data after successful submission
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.cpindex;
                            setParticipantIndex(wcategoryData);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                            setIsButtonReminderDisabled(false);
                        }
                    });
                    setIsButtonReminderDisabled(false);

                    //history.push('/admin/workshop/manage-particpant-order');
                }
                else {

                    swal('Success', "Error", 'success');
                    setIsButtonReminderDisabled(false);

                }

            });


        });




        //swal('Success', "Submit Reminder Email", 'success');
    };



    const handleClickPrintRecieptEmail = (row) => {
        const id = row.id;
        const paymentStatus = row.cppyament.some((cppyament) => cppyament.status)

        const data = {
            eventid: eventid, // Make sure eventid is defined
            paymentStatus: paymentStatus,
        }

        console.log('Sending data:', data); // Debug log

        setIsButtonPrintReceiptReminderDisabled(true);

        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/conference-participant-print-receipt-email-send/${id}`, data).then(res => {
                if (res.data.status === 200) {
                    // Handle PDF printing
                    const pdfData = res.data.pdf_data;
                    const pdfName = res.data.pdf_name;

                    // Decode base64 and create PDF
                    const byteCharacters = atob(pdfData);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // Open PDF in new window for printing
                    const url = URL.createObjectURL(blob);
                    const printWindow = window.open(url, '_blank');

                    // printWindow.onload = function() {
                    //     printWindow.print();
                    // };

                    swal('Success', res.data.message, 'success');

                    // Refresh data
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            setParticipantIndex(res.data.cpindex);
                        }
                    });
                    setIsButtonPrintReceiptReminderDisabled(false);

                } else {
                    swal('Error', res.data.message, 'error');
                }
                setIsButtonPrintReceiptReminderDisabled(false);
            }).catch(error => {
                console.error('Error:', error);
                swal('Error', error.response?.data?.message || 'Something went wrong', 'error');
                setIsButtonPrintReceiptReminderDisabled(false);
            });
        });
    };





    const handleClickRecieptEmail = (row) => {

        const id = row.id;
        const paymentStatus = row.cppyament.some((cppyament) => cppyament.status)

        //alert(`Function accessed with ID: ${id} and paymentStatus: ${paymentStatus}`);


        const data = {
            eventid,
            paymentStatus,

        }
        setIsButtonSendReceiptReminderDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-participant-receipt-email-send/${id}`, data).then(res => {

                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');

                    // Fetch the updated data after successful submission
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.cpindex;
                            setParticipantIndex(wcategoryData);
                            setIsButtonSendReceiptReminderDisabled(false);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                            setIsButtonSendReceiptReminderDisabled(false);
                        }
                    });
                    setIsButtonSendReceiptReminderDisabled(false);

                    //history.push('/admin/workshop/manage-particpant-order');
                }
                else {

                    swal('Success', "Error", 'success');
                    setIsButtonSendReceiptReminderDisabled(false);

                }

            });


        });




        //swal('Success', "Submit Reminder Email", 'success');
    };




    const handleClickSendWhatsappCustomeMessage = (row) => {
        const id = row.id;
        const paymentStatus = row.cppyament.some((payment) => payment.status);
        const data = { eventid, paymentStatus };

        setIsButtonSendCustomReminderDisabled(true);

        axios.post(`/api/conference-participant-whatsapp-custom-message/${id}`, data)
            .then(res => {
                let parsedData;

                if (typeof res.data === "string") {
                    // Extract JSON from any extra text
                    const match = res.data.match(/\{.*\}$/s);
                    if (match) {
                        parsedData = JSON.parse(match[0]);
                    } else {
                        swal("Error", "Invalid response from server", "error");
                        return;
                    }
                } else {
                    parsedData = res.data;
                }

                if (parsedData.status === 200) {
                    swal("Success", parsedData.message, "success");
                    axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const wcategoryData = res.data.cpindex;
                            setParticipantIndex(wcategoryData);
                            setIsButtonSendCustomReminderDisabled(false);
                        } else {
                            swal('Error', 'Check API Something Wrong', 'error');
                            setIsButtonSendCustomReminderDisabled(false);
                        }
                    });
                    setIsButtonSendCustomReminderDisabled(false);
                } else {
                    swal("Error", parsedData.message || "Message Not Sent", "error");
                    setIsButtonSendCustomReminderDisabled(false);
                }
            })
            .catch(err => {
                console.error(err);
                swal("Error", "Something went wrong", "error");
                setIsButtonSendCustomReminderDisabled(false);
            });


    };




    //     const handleClickReminderSMS = (row) => {
    //     const id = row.id;
    //     const eventid = row.eventid; // Make sure this is defined
    //     const paymentStatus = row.cppyament?.some((cppyament) => cppyament.status) || false;

    //     console.log('Sending reminder:', { id, eventid, paymentStatus });

    //     const data = {
    //         eventid: eventid,
    //         paymentStatus: paymentStatus,
    //     }

    //     axios.get('/sanctum/csrf-cookie').then(() => {
    //         axios.post(`/api/conference-participant-send-whatsapp-reminder/${id}`, data, { 
    //             withCredentials: true,
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Accept': 'application/json'
    //             }
    //         })
    //         .then(res => {
    //             console.log('Full response:', res);
    //             console.log('Response data:', res.data);

    //             // Check if response has status property directly
    //             if (res.data && res.data.status === 200) {
    //                 swal('Success', res.data.message, 'success'); 
    //             } else {
    //                 // If no status property, check HTTP status code
    //                 if (res.status === 200) {
    //                     swal('Success', res.data.message || 'Message sent successfully', 'success');
    //                 } else {
    //                     swal('Error', res.data.message || "Message Not Send", 'error');
    //                 }
    //             }
    //         })
    //         .catch(err => {
    //             console.error('API Error:', err);
    //             console.error('Error response:', err.response);
    //             swal('Error', err.response?.data?.message || 'Something went wrong', 'error');
    //         });
    //     });
    // };

    const handleClickReminderSMS = (row) => {
        const id = row.id;
        const paymentStatus = row.cppyament.some(c => c.status);

        const data = { eventid, paymentStatus };
        setIsButoonSendWhatsappReminderDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(() => {
            axios.post(`/api/conference-participant-send-whatsapp-reminder/${id}`, data, { withCredentials: true })
                .then(res => {


                    let parsedData;
                    try {
                        // Extract JSON at the end of the string
                        const match = res.data.match(/\{.*\}$/s);
                        if (match) {
                            parsedData = JSON.parse(match[0]);
                        } else {
                            throw new Error('No JSON found');
                        }
                    } catch (e) {
                        console.error('Failed to parse response:', e);
                        swal('Error', 'Invalid response from server', 'error');
                        return;
                    }

                    // Now show success or error
                    if (parsedData.status == 200) {

                        axios.get(`api/conference-particpant-index?id=${eventid}`).then(res => {
                            if (res.status === 200) {
                                const wcategoryData = res.data.cpindex;
                                setParticipantIndex(wcategoryData);
                                setIsButoonSendWhatsappReminderDisabled(false);
                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                                setIsButoonSendWhatsappReminderDisabled(false);
                            }
                        });
                        swal('Success', parsedData.message, 'success');
                        setIsButoonSendWhatsappReminderDisabled(false);
                    } else {
                        swal('Error', parsedData.message || "Message Not Sent", 'error');
                        setIsButoonSendWhatsappReminderDisabled(false);
                    }
                })
                .catch(err => {
                    console.error('API Error:', err.response?.data || err);
                    swal('Error', err.response?.data?.message || 'Something went wrong', 'error');
                    setIsButoonSendWhatsappReminderDisabled(false);
                });
        });
    };


    // Define the myFun function outside handleBarcodeClick
    // Define the myFun function in the main window
    // Define the myFun function globally
    function myFun(id) {

        axios.post('/api/conference-particpant-badge-print', { id: id })
            .then(res => {
                if (res.data.status === 200) {
                    //window.print(); // Proceed to print
                    //swal("Success" , res.data.message ,'success')
                } else {
                    alert('Error: Message Not Sent');
                }
            })
            .catch(error => {
                console.error("API Error:", error.response || error.message || error);
                alert('Error: An error occurred');
            });
    }





    const handleBarcodeClick = (row) => {
        setPrintingId(row.id);
        const id = row.id;
        const name = row.participant_name;
        const nameTitle = row.name_title;
        const cpConferenceArray = row.cpconference || [];
        const ActiveConference = cpConferenceArray
            .filter((cpCode) => cpCode.payment_status === 1)
            .map((cpCode) => cpCode.conference_name);

        const printWindow = window.open('', '_blank');

        if (!printWindow) {
            alert('Popup blocked. Please allow popups for this website.');
            return;
        }

        // Assign the myFun function to the print window context
        printWindow.myFun = myFun;

        printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Print</title>
            <style>
                body {
                    text-align: center;
                    margin: 0;
                    padding: 20px;
                }
                #content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: left;
                    padding-top: 190px;
                }
                #printButton {
                    display: block;
                    position: fixed;
                    top: 0;
                    right: 0;
                    margin: 20px;
                    padding: 10px;
                    background-color: green;
                    color: white;
                    border: none;
                    cursor: pointer;
                }
                @media print {
                    #printButton {
                        display: none;
                    }
                    @page {
                        size: auto;
                        margin: 0;
                    }
                }
            </style>
            <script type="text/javascript" src="https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"></script>
            <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.4/dist/JsBarcode.all.min.js"></script>
        </head>
        <body>
            <button id="printButton" onclick="window.print(); myFun(${id});">Print</button>
            <div id="content">
                <div id="qrcode" style="margin-bottom: 0.5em;"></div>
                <h3 style="text-align: center; line-height: 1.5; margin: 0;">ID: ${id}</h3>
                <h3 style="text-align: center; line-height: 1; margin: 0;">Name: ${nameTitle} ${name}</h3>
                <div id="barcode-container">
                    <svg id="barcode"></svg>
                </div>
            </div>
            <script>
                document.addEventListener('DOMContentLoaded', () => {
                    // Generate QR Code
                    const qrcodeSvg = document.getElementById("qrcode");
                    new QRCode(qrcodeSvg, {
                        text: '${id}',
                        width: 128,
                        height: 128,
                    });

                    // Generate Barcode
                    // const barcodeSvg = document.getElementById("barcode");
                    // JsBarcode(barcodeSvg, '${id}', {
                    //     format: "CODE128",
                    //     displayValue: true,
                    //     fontSize: 14,
                    //     textMargin: 10,
                    // });

                    // Adjust barcode dimensions
                    barcodeSvg.setAttribute('width', '128');
                    barcodeSvg.setAttribute('height', '80');
                    barcodeSvg.setAttribute('preserveAspectRatio', 'none');
                    
                });

            </script>
        </body>
        </html>
    `);

        printWindow.document.close();
    };





    const formatParticipantData = (participantData) => {
        const cppyamentArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];

        // Extracting the total payment from the first element of wppyament array
        const totalPayment = cppyamentArray.length > 0
            ? cppyamentArray[0].total_payment
            : '0.00';
        const grandTotalPayment = cppyamentArray.length > 0
            ? cppyamentArray[0].grand_total_payment
            : '0.00';


        const cppyamentypeArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];
        const payment_type = cppyamentypeArray.length > 0
            ? cppyamentypeArray[0].payment_type
            : 'null';

        const cppyamenstatusArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];
        const payment_status = cppyamenstatusArray.length > 0
            ? cppyamenstatusArray[0].status
            : 'null';

        const cppyamensendemailArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];
        const payment_send_email = cppyamensendemailArray.length > 0
            ? cppyamensendemailArray[0].send_email
            : 'null';

        const wppyamensendsmsArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];
        const payment_send_sms = wppyamensendsmsArray.length > 0
            ? wppyamensendsmsArray[0].send_sms
            : 'null';

        // Accessing the category name through the wpcategory relationship
        const categoryName = participantData.cpcategory
            ? participantData.cpcategory.conference_category_title
            : 'Unknown Category';

        const conferenceDay = participantData.cpconference
            ? participantData.cpconference.map((conference) => conference.conference_day)
            : [];


        const wppyamenRefnoArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];
        const trans_ref_no = wppyamenRefnoArray.length > 0
            ? wppyamenRefnoArray[0].trans_ref_no
            : 'null';

        const wppyamenPaymentMethodArray = Array.isArray(participantData.cppyament) ? participantData.cppyament : [];
        const payment_method = wppyamenPaymentMethodArray.length > 0
            ? wppyamenRefnoArray[0].payment_method
            : 'null';
        return {
            'Invoice ID': `INV${participantData.id}`,
            ...(trans_ref_no !== null && trans_ref_no !== undefined ? { 'Transaction Ref': trans_ref_no } : {}),
            'User ID / Receipt No': `${participantData.id}`,
            'Amount': `${totalPayment}`,
            'Grand Total': `${grandTotalPayment}`,
            'Registration': `${categoryName}: ${conferenceDay.length > 0 ? conferenceDay.join(', ') : 'No Workshops'}`,
            'Payment Type': `${payment_type}`,
            'Payment Method': `${payment_method}`,

            'Payment Paid': `${payment_status == 0 ? "Not Paid" : "Paid"}`,
            'Sent Mail': `${payment_send_email == 0 ? "Not Send" : "Send"}`,
            'Send Receipt': `${payment_send_sms == 0 ? "Not Send" : "Send"}`,
            'Date Time': participantData.created_at,
            'Payment Paid Date Time': participantData.updated_at,
        };
    };
    const formattedInvoiceData = formatParticipantData(participantSingleData);

    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,


    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >

                </h4>
                <Card sx={{ width: '82vw', float: 'center' }} >

                    <CardContent >

                        <Box component="form" noValidate sx={{ mt: 3 }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography component="h1" variant="h5">
                                    Conference Participants Order
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span>Total Records: {totalRecords}</span>
                                    <span style={{ marginLeft: '10px' }}>|</span>
                                    <span style={{ marginLeft: '10px' }}>Filtered Records: {filteredRecordsCount}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Grid item xs={4} style={{ marginRight: '10px' }}>
                                        <TextField
                                            fullWidth
                                            label="Filter By: Name"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={4} style={{ marginRight: '10px' }}>
                                        <TextField
                                            fullWidth
                                            label="Filter By: BarcodeID"
                                            value={searchTermID}
                                            onChange={(e) => setSearchTermID(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Select value={filterPaymentStatus} onChange={handleFilterPaymentStatusChange}>
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="paid">Verified</MenuItem>
                                            <MenuItem value="unpaid">UnVerified</MenuItem>
                                            <MenuItem value="free">Free</MenuItem>
                                            {/* <MenuItem value="allverified">All-Verified</MenuItem> */}


                                        </Select>
                                    </Grid>
                                </div>

                                {/* { permissions['p_conference-order-export'] === true ?
                                        <Button
                                            onClick={handleConferenceDownloadCSV}
                                            sx={{
                                                float: 'right',
                                                marginTop: '2%',
                                                backgroundColor: backGroundButtonByEvent,
                                                ":hover": {
                                                    color: "white"
                                                }
                                            }}
                                            color='success'
                                            size='small'
                                            variant='contained'
                                        >
                                            <FileDownloadIcon />
                                            Download CSV
                                        </Button>
                                        : ""} */}
                                {
                                    permissions['p_conference-order-export'] === true ?
                                        <Button
                                            onClick={handleConferenceDownloadExcel}
                                            sx={{
                                                float: 'right',
                                                marginTop: '2%',
                                                backgroundColor: backGroundButtonByEvent,
                                                ":hover": {
                                                    color: "white"
                                                }
                                            }}
                                            color='success'
                                            size='small'
                                            variant='contained'
                                        >
                                            <FileDownloadIcon />
                                            Download CSV
                                        </Button>
                                        : ""}

                                {
                                    permissions['p_conference-participant-add'] === true ?

                                        <Button sx={{
                                            float: 'right',
                                            marginTop: '2%',
                                            backgroundColor: backGroundButtonByEvent,
                                            ":hover": {
                                                color: "white"
                                            }
                                        }}
                                            color='success'
                                            size='small'
                                            variant='contained'
                                            component={Link}
                                            //to="/admin/conference/join-as"
                                            to="/admin/conference/add-particpant"
                                        >
                                            Add New
                                        </Button> : ""}

                            </div>
                            <Button
                                onClick={handleConferenceVerifiedDownloadCSV}
                                sx={{
                                    float: 'right',
                                    marginTop: '2%',
                                    backgroundColor: backGroundButtonByEvent,
                                    ":hover": {
                                        color: "white"
                                    }
                                }}
                                color='success'
                                size='small'
                                variant='contained'
                            >
                                <FileDownloadIcon />
                                New Verified Download
                            </Button>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>User ID</TableCell>
                                            <TableCell align="left">Full Name</TableCell>

                                            <TableCell align="left">Registration</TableCell>
                                            <TableCell align="left">Paid Amount</TableCell>
                                            <TableCell align="left">Company Name</TableCell>
                                            <TableCell align="left">Payment Type</TableCell>
                                            <TableCell align="left">Payment Status</TableCell>
                                            <TableCell align="left">Ref No</TableCell>
                                            {/* <TableCell align="left">Recipt Sent</TableCell> */}
                                            <TableCell align="left">Payment Method</TableCell>
                                            <TableCell align="left">Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      
                                      
                                        {filteredPosts && filteredPosts?.slice(startIndex, endIndex).map((row, index) => (
                                         
                                         
                                         <TableRow key={index}>
                                                <>
                                                    <TableCell>{row?.id}</TableCell>
                                                    <TableCell>{row?.name_title}: {row?.participant_name}</TableCell>


                                                    <TableCell>{row?.cpcategory?.conference_category_title}</TableCell>

                                                    <TableCell>
                                                        {/* {row?.cppyament.map((cppyament, index) => (
                                                            <div key={index}>{cppyament.total_paid_amount}</div>
                                                            
                                                        ))} */}
                                                        {row?.cppyament.map((cppyament, index) => (
                                                            <div key={index}>
                                                                {(cppyament?.status == 0)
                                                                    ? '0.0000'
                                                                    : cppyament.total_payment}
                                                            </div>
                                                        ))}


                                                    </TableCell>
                                                    <TableCell>{row?.participant_company}</TableCell>
                                                    <TableCell>
                                                        {row?.cppyament?.map((cppyament, index) => (
                                                            <div key={index}>{cppyament?.payment_method}</div>
                                                        ))}
                                                    </TableCell>
                                                    {/* <TableCell>
                                                        {row.pp_ledger && row.pp_ledger.map((ledger, index) => (
                                                            <div key={index}>{ledger.payment_type}</div>
                                                        ))
                                                        }
                                                    </TableCell> */}
                                                    <TableCell>
                                                        {row.cppyament.map((wppyament, index) => (
                                                            <div key={index}>{wppyament?.status === 0 ? 'No' : 'Yes'}</div>
                                                        ))}
                                                    </TableCell>
                                                    <TableCell>
                                                        {row.cppyament.map((cppyament, index) => (
                                                            <div key={index}>
                                                                {
                                                                    cppyament?.trans_ref_no === "" || cppyament?.trans_ref_no === null ? "" :

                                                                        <Button variant="outlined" onClick={() => handleModalChallan(cppyament)} sx={{ backgroundColor: backGroundButtonByEvent, color: "black", ":hover": { color: backGroundButtonByEvent }, }}>
                                                                            View Challan
                                                                            {/* {wppyament.trans_ref_no === "" || wppyament.trans_ref_no === null ? "null" : wppyament.trans_ref_no} */}
                                                                        </Button>
                                                                }
                                                            </div>
                                                        ))}

                                                    </TableCell>
                                                    <TableCell>
                                                        {row.cppyament.map((wppyament, index) => (
                                                            <div key={index} >{wppyament?.payment_method}</div>
                                                        ))}
                                                        <hr></hr>
                                                        {/* {row.pp_ledger && row.pp_ledger.map((ledger, index) => (

                                                            <div key={index}>.{ledger.payment_method}/{ledger.workshop_amount}</div>
                                                        ))
                                                        } */}
                                                    </TableCell>



                                                    < TableCell >


                                                        {permissions['p_conference-order-verifiction'] === true && row.cppyament?.some((wppyament) => wppyament.status === 0) ? (
                                                            <Select
                                                                value={selectedOptions[row.id] || ''}
                                                                onChange={(event) => handleChange(event, row)}
                                                                displayEmpty
                                                                inputProps={{ 'aria-label': 'Verify' }}
                                                                sx={{ width: '100%' }}
                                                            >
                                                                <MenuItem value="" disabled>Verify</MenuItem>
                                                                <MenuItem onClick={() => handleSelection('receipt', row)} value="receipt">Receipt</MenuItem>
                                                                <MenuItem onClick={() => handleSelection('bank', row)} value="bank">Bank</MenuItem>
                                                                {/* <MenuItem onClick={() => handleSelection('cash', row)} value="cash">Cash</MenuItem> */}
                                                                <MenuItem onClick={() => handleSelection('qrcodeshow', row)} value="qrcodeshow">Display QrCode</MenuItem>
                                                            </Select>
                                                        ) : ''}

                                                        <div>
                                                            <Button
                                                                sx={{
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    marginTop: 1,
                                                                    marginBottom: 1,
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                onClick={() => handleClickView(row.id)}
                                                            >
                                                                View
                                                            </Button>
                                                        </div>


                                                        {row.cppyament?.some((cppyament) => cppyament.status === 0) ? null : (
                                                            <div>
                                                                <Button
                                                                    sx={{
                                                                        ":hover": { color: "white" },
                                                                        backgroundColor: backGroundButtonByEvent,
                                                                        marginTop: 1,
                                                                        marginBottom: 1,
                                                                    }}
                                                                    color='primary'
                                                                    size='small'
                                                                    variant='contained'
                                                                    onClick={() => handleBarcodeClick(row)}
                                                                >
                                                                    QrCode
                                                                </Button>
                                                            </div>
                                                        )}
                                                        {row.cppyament.some((cppyament) => cppyament.status === 1) ? <div>
                                                            <Button
                                                                sx={{
                                                                    marginBottom: 1,
                                                                    marginTop: 1,
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '1px solid white',
                                                                        padding: '0 6px',
                                                                        marginLeft: '20px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                // onClick={handleClickReminderEmail}
                                                                onClick={() => handleClickPrintRecieptEmail(row, row.cppyament.some((cppyament) => cppyament.status))}
                                                                disabled={isButtonPrintReceiptReminderDisabled}
                                                            >
                                                                Print Receipt
                                                            </Button>
                                                        </div> : ''}


                                                        <div>
                                                            {/* {
                                                                permissions['p_workshop-order-view-workshop-verifiction'] === true ? */}
                                                            {
                                                                permissions['p_workshop-order-view-workshop-verifiction'] === true && row?.cppyament.some((cppyament) => cppyament.status === 1) ? (
                                                                    <Button
                                                                        sx={{
                                                                            ":hover": { color: "white" },
                                                                            backgroundColor: backGroundButtonByEvent,
                                                                            marginTop: 1,
                                                                            marginBottom: 1,
                                                                        }}
                                                                        color='primary'
                                                                        size='small'
                                                                        variant='contained'
                                                                        onClick={() => handleClickViewConference(row.id)}
                                                                    >
                                                                        View Conference
                                                                    </Button>
                                                                ) : ''}
                                                        </div>
                                                        {row.cppyament.some((cppyament) => cppyament.status === 1) ? <div>
                                                            <Button
                                                                sx={{
                                                                    marginBottom: 1,
                                                                    marginTop: 1,
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '1px solid white',
                                                                        padding: '0 6px',
                                                                        marginLeft: '20px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                endIcon={<span>{row.reminder_count || 0}</span>}
                                                                // onClick={handleClickReminderEmail}
                                                                onClick={() => handleClickReminderEmail(row, row.cppyament.some((cppyament) => cppyament.status))}
                                                                disabled={isButtonReminderDisabled}
                                                            >
                                                                Send QrCode
                                                            </Button>
                                                        </div> : (
                                                            <div>
                                                                <Button
                                                                    sx={{
                                                                        marginBottom: 1,
                                                                        marginTop: 1,
                                                                        ":hover": { color: "white" },
                                                                        backgroundColor: backGroundButtonByEvent,
                                                                        position: 'relative',
                                                                        '& .MuiButton-endIcon': {
                                                                            borderLeft: '1px solid white',
                                                                            padding: '0 6px',
                                                                            marginLeft: '20px',
                                                                        }
                                                                    }}
                                                                    color='primary'
                                                                    size='small'
                                                                    variant='contained'
                                                                    endIcon={<span>{row.reminder_count || 0}</span>}
                                                                    // onClick={handleClickReminderEmail}
                                                                    onClick={() => handleClickReminderEmail(row, row.cppyament.some((cppyament) => cppyament.status))}
                                                                    disabled={isButtonReminderDisabled}
                                                                >
                                                                    Reminder Email
                                                                </Button>
                                                            </div>
                                                        )}

                                                        {row.cppyament.some((cppyament) => cppyament.status === 1) ? <div>
                                                            <Button
                                                                sx={{
                                                                    marginBottom: 1,
                                                                    marginTop: 1,
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '1px solid white',
                                                                        padding: '0 6px',
                                                                        marginLeft: '20px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                endIcon={<span>{row.receipt_count || 0}</span>}
                                                                // onClick={handleClickReminderEmail}
                                                                onClick={() => handleClickRecieptEmail(row, row.cppyament.some((cppyament) => cppyament.status))}
                                                                disabled={isButtonSendReceiptReminderDisabled}
                                                            >
                                                                Send Receipt
                                                            </Button>
                                                        </div> : ''}
                                                        <div>
                                                            <Button
                                                                sx={{
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '2px solid white',
                                                                        padding: '0 8px',
                                                                        marginLeft: '25px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                endIcon={<span>{row?.whatsapp_count || 0}</span>}
                                                                onClick={() => handleClickReminderSMS(row, row.cppyament.some((cppyament) => cppyament.status))}
                                                                disabled={isButoonSendWhatsappReminderDisabled}
                                                            >
                                                                Reminder WhatsApp
                                                            </Button>
                                                        </div>

                                                        {row.cppyament.some((cppyament) => cppyament.status === 1) ? <div>
                                                            <Button
                                                                sx={{
                                                                    marginBottom: 1,
                                                                    marginTop: 1,
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    position: 'relative',
                                                                    '& .MuiButton-endIcon': {
                                                                        borderLeft: '1px solid white',
                                                                        padding: '0 6px',
                                                                        marginLeft: '20px',
                                                                    }
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                endIcon={<span>{row.coustom_whatsapp_count || 0}</span>}

                                                                onClick={() => handleClickSendWhatsappCustomeMessage(row, row.cppyament.some((cppyament) => cppyament.status))}
                                                                disabled={isButtonSendCustomReminderDisabled}
                                                            >
                                                                Send Custom message
                                                            </Button>
                                                        </div> : ''}
                                                    </TableCell>


                                                </>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                               <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={filteredPosts?.length || 0}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                              />
                            </TableContainer>


                        </Box>
                    </CardContent>
                </Card>
            </Box>



            <Dialog
                component="form"
                onSubmit={addReceiptData}
                open={openModalReceipt}
                onClose={handleCloseModal} >
                <DialogTitle>Add Receipt / Cash Detail</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Invoice No"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name='participant_id'
                        value={`INV${participantSingleData.id || ""}`}

                        disabled={true}
                    // No need for onChange if you want it to be read-only
                    // onChange={(e) => setAddReceipt({ ...addReceipt, participant_id: e.target.value })}
                    />
                    <TextField
                        label="Bank Name / Cash"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="participant_bank"
                        value={addReceipt.participant_bank || ""}

                        onChange={handleInputReceipt}

                    />
                    <TextField
                        label="Ref Number"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="participant_ref_no"
                        value={addReceipt.participant_ref_no}
                        //onChange={(e) => setAddReceipt({ ...addReceipt, participant_ref_no: e.target.value })}
                        onChange={handleInputReceipt}
                    // Add any additional TextField props or styles as needed
                    />
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {participantSingleData?.cpconference?.map((conference, key) => {
                                    const participantId = participantSingleData?.id || ''; // Ensure participantSingleData is not null or undefined
                                    const conferenceId = conference?.id || ''; // Ensure conference is not null or undefined

                                    // Initialize variables for discounted amount and coupon code
                                    let discountedAmount = conference.conference_amount; // Default to original conference amount
                                    let couponCodeDisplay = ''; // Initialize to empty string
                                    let discount = 0;
                                    if (participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0) {
                                        // Filter and map coupon codes for the current conference
                                        participantSingleData.cpcoupon
                                            .filter(coupon => coupon.conference_id === conference.conference_id) // Filter by conference ID
                                            .forEach((coupon, couponIndex) => {
                                                // Determine the discount based on the coupon type

                                                if (coupon.coupon_discount_type === 'fixed') {
                                                    discount = parseFloat(coupon.coupon_amount);
                                                } else if (coupon.coupon_discount_type === 'percentage') {
                                                    // Calculate the percentage discount
                                                    const percentage = parseFloat(coupon.coupon_amount);
                                                    discount = (parseFloat(conference.conference_amount) * percentage) / 100;
                                                }
                                                // Calculate the final amount after discount
                                                discountedAmount -= discount;
                                                // Add the coupon code to the display
                                                couponCodeDisplay += coupon.coupon_code + ', ';
                                            });

                                        // Remove the trailing comma and space
                                        couponCodeDisplay = couponCodeDisplay.slice(0, -2);
                                    }


                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{conference.conference_name}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{conference.conference_day}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>

                                                {conference.payment_status === 0 ? (

                                                    <Checkbox
                                                        checked={checkedWorkshops[conference.id] || false}
                                                        onChange={() => handleConferenceCheckboxChange(conference.id)}
                                                        disabled={isCheckboxDisabled(conference).isDisabled} />

                                                ) : (
                                                    "Paid"
                                                )}
                                                <br></br>
                                                {isCheckboxDisabled(conference).seatLimitMessage && (
                                                    <span style={{ color: 'red' }}>
                                                        {isCheckboxDisabled(conference).seatLimitMessage}
                                                    </span>
                                                )}


                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{discountedAmount}</TableCell>

                                            <TableCell style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                {participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0 ? (
                                                    participantSingleData.cpcoupon
                                                        .filter(coupon => coupon.conference_id === conference.conference_id)
                                                        .map((coupon, couponIndex) => (
                                                            <div key={couponIndex} style={{ marginBottom: '12px' }}>
                                                                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>CouponDetails:</div>
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Type: </span>
                                                                    <span>
                                                                        {coupon.coupon_discount_type === 'percentage' ? 'Percentage' : 'Fixed'}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Value: </span>
                                                                    <span>
                                                                        {coupon.coupon_discount_type === 'percentage'
                                                                            ? `${parseFloat(coupon.coupon_amount)}%`
                                                                            : `${parseFloat(coupon.coupon_amount)} SAR`}
                                                                    </span>
                                                                </div>
                                                                {coupon.coupon_discount_type === 'percentage' ? (
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }}>Discount: </span>
                                                                        <span>{parseFloat(discount)} SAR</span>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }}> Discount: </span>
                                                                        <span>{parseFloat(coupon.coupon_amount)} SAR </span>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Code: </span>
                                                                    <span>{coupon.coupon_code}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div>No coupons available</div>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}

                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalDiscountedAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Paid:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Remining:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalUnPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Grand Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{grandTotalViewWorkshopAmountFormatted}</TableCell>
                                </TableRow>

                            </TableBody>

                        </Table>
                    </TableContainer>
                </DialogContent>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 2 }}
                    disabled={isSaveButtonDisabled}
                >
                    Save
                </Button>
            </Dialog>


            <Dialog
                component="form"
                onSubmit={submitBankData}
                open={openModalBank}
                onClose={handleCloseModalBank}>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        {/* Left side content */}
                        <Typography variant="h6">Add Bank Detailsccc</Typography>

                        {/* Right side content */}
                        {participantSingleData?.event_affiliate_status === 1 && (
                            <>
                                <Typography variant="body2" sx={{ color: 'green' }}>
                                    Affiliate Applied
                                </Typography>
                            </>

                        )}
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        label="Invoice No"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name='participant_id'
                        value={`INV${participantSingleData.id || ""}`}
                        disabled={true} />
                    <TextField
                        label="Bank Name"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={(addBank.bank_name ? addBank.bank_name : bankNameforVeri.join('  ,  ')) || ''}
                        onChange={(e) => setAddBank({ ...addBank, bank_name: e.target.value })}

                    />
                    <TextField
                        label="Ref Number"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={(addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join('  ,  ')) || ""}
                        onChange={(e) => setAddBank({ ...addBank, trans_ref_no: e.target.value })} />


                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {participantSingleData?.cpbank_pay_tran?.map((bankDeatials, key) => (
                                    <TableRow key={key}>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{bankDeatials.bank_name}</TableCell>
                                        <TableCell>
                                            {
                                                bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "" :
                                                    <Button variant="outlined" onClick={() => handleModalBankReciept(bankDeatials)}>
                                                        View Bank Receipt
                                                        {/* {bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "null" : bankDeatials.trans_ref_no} */}
                                                    </Button>
                                            }

                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>

                        </Table>
                    </TableContainer>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {participantSingleData?.cpconference?.map((conference, key) => {

                                    const participantId = participantSingleData?.id || ''; // Ensure participantSingleData is not null or undefined
                                    const conferenceId = conference?.id || ''; // Ensure workshop is not null or undefined

                                    // Initialize variables for discounted amount and coupon code
                                    let conferenceOwnPrice = conference.conference.conference_amount; // Default to original workshop amount
                                    let discountedAmount = conference.conference_amount; // Default to original workshop amount
                                    let couponCodeDisplay = ''; // Initialize to empty string
                                    let discount = 0;
                                    if (participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0) {
                                        // Filter and map coupon codes for the current workshop
                                        participantSingleData.cpcoupon
                                            .filter(coupon => coupon.conference_id === conference.conference_id) // Filter by workshop ID
                                            .forEach((coupon, couponIndex) => {
                                                // Determine the discount based on the coupon type

                                                if (coupon.coupon_discount_type === 'fixed') {
                                                    discount = parseFloat(coupon.coupon_amount);
                                                } else if (coupon.coupon_discount_type === 'percentage') {
                                                    // Calculate the percentage discount
                                                    const percentage = parseFloat(coupon.coupon_amount);
                                                    discount = (parseFloat(conference.conference_amount) * percentage) / 100;
                                                }
                                                // Calculate the final amount after discount
                                                discountedAmount -= discount;
                                                // Add the coupon code to the display
                                                couponCodeDisplay += coupon.coupon_code + ', ';
                                            });

                                        // Remove the trailing comma and space
                                        couponCodeDisplay = couponCodeDisplay.slice(0, -2);
                                    }



                                    return (
                                        <TableRow key={key}>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{conference.conference_name}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{conference.conference_day}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                {/* {workshop.payment_status === 0 ? (
                                                    <Checkbox
                                                        checked={checkedWorkshops[workshop.id] || false}
                                                        onChange={() => handleWrokshopCheckboxChange(workshop.id)}
                                                    />
                                                ) : (
                                                    "Paid"
                                                )} */}
                                                {conference.payment_status === 0 ? (

                                                    <Checkbox
                                                        checked={checkedWorkshops[conference.id] || false}
                                                        onChange={() => handleConferenceCheckboxChange(conference.id)}
                                                        disabled={isCheckboxDisabled(conference).isDisabled} />

                                                ) : (
                                                    "Paid"
                                                )}
                                                <br></br>
                                                {isCheckboxDisabled(conference).seatLimitMessage && (
                                                    <span style={{ color: 'red' }}>
                                                        {isCheckboxDisabled(conference).seatLimitMessage}
                                                    </span>
                                                )}

                                            </TableCell>
                                            {/* <TableCell style={{ border: '1px solid #ddd' }}>{discountedAmount} </TableCell> */}
                                            <TableCell style={{ border: '1px solid #ddd' }}>
                                                {participantSingleData?.event_affiliate_status === 1 ? (
                                                    <>
                                                        <span style={{ textDecoration: 'line-through', marginRight: '5px' }}>
                                                            {conferenceOwnPrice} {/* Original price */}
                                                        </span><br></br>
                                                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                            {discountedAmount} {/* Discounted price */}
                                                        </span>
                                                    </>
                                                ) : (
                                                    discountedAmount
                                                )}
                                            </TableCell>


                                            <TableCell style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                {participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0 ? (
                                                    participantSingleData.cpcoupon
                                                        .filter(coupon => coupon.conference_id === conference.conference_id)
                                                        .map((coupon, couponIndex) => (
                                                            <div key={couponIndex} style={{ marginBottom: '12px' }}>
                                                                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>CouponDetails:</div>
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Type: </span>
                                                                    <span>
                                                                        {coupon.coupon_discount_type === 'percentage' ? 'Percentage' : 'Fixed'}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Value: </span>
                                                                    <span>
                                                                        {coupon.coupon_discount_type === 'percentage'
                                                                            ? `${parseFloat(coupon.coupon_amount)}%`
                                                                            : `${parseFloat(coupon.coupon_amount)} SAR`}
                                                                    </span>
                                                                </div>
                                                                {coupon.coupon_discount_type === 'percentage' ? (
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }}>Discount: </span>
                                                                        <span>{parseFloat(discount)} SAR</span>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }}>Discount: </span>
                                                                        <span>{parseFloat(coupon.coupon_amount)} SAR</span>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Code: </span>
                                                                    <span>{coupon.coupon_code}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div>No coupons available</div>
                                                )}
                                            </TableCell>




                                        </TableRow>
                                    );
                                })}
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalDiscountedAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Paid:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Remining:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalUnPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Grand Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{grandTotalViewWorkshopAmountFormatted}</TableCell>
                                </TableRow>

                            </TableBody>

                        </Table>
                    </TableContainer>
                </DialogContent>

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 2 }}
                    disabled={isSaveButtonDisabled}
                >
                    Save
                </Button>
            </Dialog>
            <Dialog open={openModalBankVeriChallan} onClose={handleCloseModalBankVeriChallan}>
                <DialogTitle>Bank challan</DialogTitle>
                <DialogActions>
                    <TableContainer component={Paper} >
                        <Table sx={{ minWidth: 350 }} aria-label="simple table" >
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Bank Name</TableCell>
                                    <TableCell align="right">Method</TableCell>
                                    <TableCell align="right">Ref&nbsp;(no)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {participantSingleData?.cpbank_pay_tran?.map((bankDeatials, key) => (
                                    <TableRow key={key}>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{bankDeatials.bank_name}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }} align="right">{bankDeatials.payment_type}</TableCell>
                                        <TableCell align="right">
                                            {
                                                bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "" :

                                                    <Button variant="outlined" onClick={() => handleModalBankReciept(bankDeatials)}>
                                                        {bankDeatials.trans_ref_no === "" || bankDeatials.trans_ref_no === null ? "null" : bankDeatials.trans_ref_no}
                                                    </Button>
                                            }

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogActions>
                <DialogContent dividers>
                    <Tabs
                        value={tabValueReceipt}
                        onChange={handleReceiptTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="Receipt tabs"
                    >
                        {tabsDataReceipt.map((tab, i) => (
                            <Tab key={i} label={tab.label} />
                        ))}
                    </Tabs>

                    <Box sx={{ mt: 2, maxHeight: "65vh", overflow: "auto", px: 1 }}>
                        {tabsDataReceipt.map((item, index) => (
                            <Box
                                key={index}
                                role="tabpanel"
                                hidden={tabValueReceipt !== index}
                                aria-labelledby={`tab-${index}`}
                            >
                                {tabValueReceipt === index && (
                                    <Stack spacing={1} alignItems="center">
                                        {item.imageUrl?.toLowerCase().endsWith(".pdf") ? (
                                            <>
                                                {/* PDF preview area (responsive) */}
                                                <Paper
                                                    elevation={1}
                                                    sx={{
                                                        width: "100%",
                                                        maxWidth: 900,
                                                        overflow: "hidden",
                                                        borderRadius: 1,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            height: { xs: "45vh", sm: "55vh", md: "60vh" },
                                                            minHeight: 220,
                                                        }}
                                                    >
                                                        <iframe
                                                            src={item.imageUrl}
                                                            title={`PDF ${index}`}
                                                            style={{ width: "100%", height: "100%", border: "none" }}
                                                        />
                                                    </Box>
                                                </Paper>

                                                {/* Buttons centered below the PDF */}
                                                <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                                                    <Button
                                                        variant="text"
                                                        size="small"
                                                        startIcon={<OpenInNewIcon fontSize="small" />}
                                                        onClick={() =>
                                                            window.open(
                                                                item.imageUrl,
                                                                "_blank",
                                                                "noopener,noreferrer"
                                                            )
                                                        }
                                                    >
                                                        Open in new window
                                                    </Button>

                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        startIcon={<PictureAsPdfIcon fontSize="small" />}
                                                        href={item.imageUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        download
                                                    >
                                                        Download
                                                    </Button>
                                                </Box>
                                            </>
                                        ) : (
                                            /* Image display (centered and contained) */
                                            <Box
                                                component="img"
                                                src={item.imageUrl}
                                                alt={`Image ${index}`}
                                                sx={{
                                                    maxWidth: "100%",
                                                    maxHeight: "60vh",
                                                    objectFit: "contain",
                                                    borderRadius: 1,
                                                }}
                                            />
                                        )}
                                    </Stack>
                                )}
                            </Box>
                        ))}
                    </Box>
                </DialogContent>


                {/* <DialogContent>
                    <Tabs value={tabValueReceipt} onChange={handleReceiptTabChange} aria-label="Tabs">
                        {tabsDataReceipt.map((tab, index) => (
                            <Tab key={index} label={tab.label} />
                        ))}
                    </Tabs>
                    <div style={{ overflowX: 'auto', maxHeight: '300px' }}>
                        {tabsDataReceipt.map((item, index) => (
                            <div key={index}>
                                {tabValueReceipt === index && (
                                    <DialogContentText id={`item-${index}-content`}>
                                        <img src={item.imageUrl} alt={`Image ${index}`} style={{ maxWidth: '100%', height: 'auto' }} />
                                        
                                    </DialogContentText>
                                  
                                )}
                            </div>
                        ))}
                    </div>
                </DialogContent> */}
            </Dialog>
            <Dialog open={openModalView} onClose={handleCloseModalView}>
                <DialogTitle>Invoice Detail {participantSingleData?.id || ""}</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {Object.keys(formattedInvoiceData).map((key) => (
                                    <TableRow key={key}>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell>
                                        <TableCell style={{ border: '1px solid #ddd' }}>{formattedInvoiceData[key]}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>


                    </TableContainer>
                </DialogContent>

            </Dialog>
            {/* view conference model */}
            <Dialog open={openModalWorkshop} onClose={handleCloseModalWorkshop}>


                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        {/* Left side content */}
                        <Typography variant="h6">View conference</Typography>

                        {/* Right side content */}
                        {participantSingleData?.event_affiliate_status === 1 && (
                            <>
                                <Typography variant="body2" sx={{ color: 'green' }}>
                                    Affiliate Applied
                                </Typography>
                            </>

                        )}
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        label="Invoice No"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name='participant_id'
                        value={`INV${participantSingleData.id || ""}`}
                        disabled={true} />
                    <TextField
                        label="Bank Name"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={(addBank.bank_name ? addBank.bank_name : bankNameforVeri.join('  ,  ')) || ''}
                        onChange={(e) => setAddBank({ ...addBank, bank_name: e.target.value })}

                    />

                    <TextareaAutosize
                        aria-label="Ref Number"
                        placeholder="Ref Number"
                        minRows={3}
                        maxRows={6}
                        value={(addBank.trans_ref_no ? addBank.trans_ref_no : bankReferanceNo.join('  ,  ')) || ""}
                        onChange={(e) => setAddBank({ ...addBank, trans_ref_no: e.target.value })}
                    />

                    <TableContainer component={Paper}>
                        <Table>

                            <TableBody>
                                {participantSingleData?.cpconference?.map((conference, key) => {
                                    const participantId = participantSingleData?.id || ''; // Ensure participantSingleData is not null or undefined
                                    const conferenceId = conference?.id || ''; // Ensure conference is not null or undefined

                                    // Initialize variables for discounted amount and coupon code
                                    let discountedAmount = conference.conference_amount; // Default to original conference amount
                                    let couponCodeDisplay = ''; // Initialize to empty string
                                    let discount = 0;
                                    if (participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0) {
                                        // Filter and map coupon codes for the current conference
                                        participantSingleData.cpcoupon
                                            .filter(coupon => coupon.conference_id === conference.conference_id) // Filter by conference ID
                                            .forEach((coupon, couponIndex) => {
                                                // Determine the discount based on the coupon type

                                                if (coupon.coupon_discount_type === 'fixed') {
                                                    discount = parseFloat(coupon.coupon_amount);
                                                } else if (coupon.coupon_discount_type === 'percentage') {
                                                    // Calculate the percentage discount
                                                    const percentage = parseFloat(coupon.coupon_amount);
                                                    discount = (parseFloat(conference.conference_amount) * percentage) / 100;
                                                }
                                                // Calculate the final amount after discount
                                                discountedAmount -= discount;
                                                // Add the coupon code to the display
                                                couponCodeDisplay += coupon.coupon_code + ', ';
                                            });

                                        // Remove the trailing comma and space
                                        couponCodeDisplay = couponCodeDisplay.slice(0, -2);
                                    }


                                    return (
                                        <TableRow key={key}>
                                            {/* <TableCell style={{ border: '1px solid #ddd' }}>{key}</TableCell> */}
                                            <TableCell style={{ border: '1px solid #ddd' }}>{conference.conference_name}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{conference.conference_day}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>

                                                {conference.payment_status === 0 ? (

                                                    <Checkbox
                                                        checked={checkedWorkshops[conference.id] || false}
                                                        onChange={() => handleConferenceCheckboxChange(conference.id)}
                                                        disabled={isCheckboxDisabled(conference).isDisabled} />

                                                ) : (
                                                    "Paid"
                                                )}
                                                <br></br>
                                                {isCheckboxDisabled(conference).seatLimitMessage && (
                                                    <span style={{ color: 'red' }}>
                                                        {isCheckboxDisabled(conference).seatLimitMessage}
                                                    </span>
                                                )}
                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{discountedAmount}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                {participantSingleData.cpcoupon && participantSingleData.cpcoupon.length > 0 ? (
                                                    participantSingleData.cpcoupon
                                                        .filter(coupon => coupon.conference_id === conference.conference_id)
                                                        .map((coupon, couponIndex) => (
                                                            <div key={couponIndex} style={{ marginBottom: '12px' }}>
                                                                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Coupon Details:</div>
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Type: </span>
                                                                    <span>
                                                                        {coupon.coupon_discount_type === 'percentage' ? 'Percentage' : 'Fixed Amount'}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Value: </span>
                                                                    <span>
                                                                        {coupon.coupon_discount_type === 'percentage'
                                                                            ? `${parseFloat(coupon.coupon_amount)}%`
                                                                            : `${parseFloat(coupon.coupon_amount)} SAR`}
                                                                    </span>
                                                                </div>
                                                                {coupon.coupon_discount_type === 'percentage' ? (
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }}>Discount: </span>
                                                                        <span>{parseFloat(discount)} SAR</span>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <span style={{ fontWeight: 'bold' }}>Fixed Discount: </span>
                                                                        <span>{parseFloat(coupon.coupon_amount)} SAR</span>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    <span style={{ fontWeight: 'bold' }}>Code: </span>
                                                                    <span>{coupon.coupon_code}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div>No coupons available</div>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}

                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalDiscountedAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Paid:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Total Remining:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{totalUnPaidWorkshopAmountFormatted}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4} style={{ border: '1px solid #ddd', textAlign: 'right' }}>Grand Total:</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{grandTotalViewWorkshopAmountFormatted}</TableCell>
                                </TableRow>

                            </TableBody>

                        </Table>


                    </TableContainer>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <Button onClick={handleWorkshopStatusSubmit} variant="contained" color="primary" disabled={isSaveButtonDisabled}>submit</Button>
                    </div>
                </DialogContent>
                <DialogContent>
                    <Tabs value={tabValueReceipt} onChange={handleReceiptTabChange} aria-label="Tabs">
                        {tabsDataReceipt.map((tab, index) => (
                            <Tab key={index} label={tab.label} />
                        ))}
                    </Tabs>

                    <div style={{ overflowX: 'auto', maxHeight: '300px' }}>
                        {tabsDataReceipt.map((tab, index) => (
                            <div key={index} hidden={tabValueReceipt !== index}>
                                <DialogContentText id={`tab-${index}-content`}>
                                    <span>{tab.content}</span>
                                    {/* {tab.imageUrl === "Receipt" ? null : <img src={tab.imageUrl} alt={tab.label} width="450" />} */}

                                </DialogContentText>
                            </div>
                        ))}
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog open={openModalChallan} onClose={handleCloseModalChallan} maxWidth="lg">
                <DialogTitle>challan </DialogTitle>
                <DialogActions>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Bank Name</TableCell>
                                    <TableCell align="right">Method</TableCell>
                                    <TableCell align="right">Ref&nbsp;(no)</TableCell>
                                    <TableCell align="right">Discount</TableCell>
                                    <TableCell align="right">Total&nbsp;(Paid)</TableCell>
                                    <TableCell align="right">Grand&nbsp;(total)</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow
                                    key={challandata.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">{challandata.bank_name}</TableCell>
                                    <TableCell align="right">{challandata.payment_method}</TableCell>
                                    <TableCell align="right">{challandata.trans_ref_no}</TableCell>
                                    {/* <TableCell align="right">{challandata.conference_discount}</TableCell> */}
                                    <TableCell align="right">
                                        {parseFloat(challandata.conference_discount) === 0
                                            ? parseFloat(challandata.grand_total_payment || 0) - parseFloat(challandata.total_paid_amount || 0)
                                            : challandata.conference_discount}
                                    </TableCell>


                                    <TableCell align="right">{challandata.total_paid_amount}</TableCell>
                                    {/* <TableCell align="right">{grandTotalViewWorkshopAmountFormatted}</TableCell> */}

                                    <TableCell align="right">
                                        {/* {parseFloat(challandata.grand_total_payment || 0) + parseFloat(challandata.conference_discount || 0)} */}
                                        {parseFloat(challandata.grand_total_payment || 0)}
                                    </TableCell>

                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogActions>
                {challandata.receipt_image !== "no_image.jpg" && challandata.receipt_image !== null && (
                    <DialogContent sx={{ width: "550px", height: "400px" }}>
                        <DialogTitle id="alert-dialog-title">
                            <a href={`${challandata.base_url}/workshop/${challandata.receipt_image}`} target="_blank">
                                <img src={`${challandata.base_url}/workshop/${challandata.receipt_image}`} width="450" alt="Receipt" />
                            </a>
                        </DialogTitle>
                    </DialogContent>
                )}
            </Dialog>

        </div>


    );
}
export default ManageConferencePartitcpnatOrder;
